import script from "./UploadOssFile.vue?vue&type=script&lang=ts&setup=true"
export * from "./UploadOssFile.vue?vue&type=script&lang=ts&setup=true"

import "./UploadOssFile.vue?vue&type=style&index=0&id=5111ab9a&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5111ab9a"]])

export default __exports__